export const paranthesisRegex = /\(([^)]+)\)/;

export function removeNewLine(str) {
  return str.replace(/\n/g, '');
}

export function newLineToSpace(str) {
  return str.replace(/\n/g, ' ');
}

export function betweenParenthesis(str) {
  return paranthesisRegex.exec(str)[1];
}

export function getIncomeAmount(str) {
  return currencyToFloat(str.replace(/ +(?= )/g,'').split(': $')[1]);
}

export function currencyToFloat(str) {
  return parseInt(str.replace('$', '').replace(/,/g,''));
}

export function toCamelCase(str) {
  return phraseToUpper(str).replace(/\s+/g, '');
}

export function phraseToUpper(str) {
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())
}

export default {
  betweenParenthesis,
  currencyToFloat,
  getIncomeAmount,
  newLineToSpace,
  paranthesisRegex,
  phraseToUpper,
  removeNewLine,
  toCamelCase
}